import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import SearchableSelect from '../../components/SearchableSelect';
import { fetchProviderGroupMembers } from '../../services/api/admin';


function PatientSearchUnderProvider(props) {
    const {
        id = 7,
        disabled,
        onSelect,
        onChange,
        errorMessage,
        customFilter = null,
        label = 'For Patient',
        name = 'patient',
        placeholder = 'Search for a patient...',
        noOptionsMessage = "No match found",
        maxOptions = 20,
        searchable = true,
        providerId,
        classes: { selectInput },
        clearable = true,
        clearInputBox,
        patientInfo
    } = props;
    const [patients, setPatients] = useState([]);
    const [currentPatientId, setCurrentPatientId] = useState(null);

    // loading patient names
    useEffect(() => {
        (async () => {
            const patientList = await fetchProviderGroupMembers(providerId);
            setPatients(
                patientList && patientList.data.map(p => ({
                    label: `${p.patientInfo.patientFullName} (${moment
                        .utc(p.patientInfo.patientBirthdate)
                        .format('MM/DD/YYYY')})`,
                    info: p,
                }))
            );
        })();
    }, []);

    useEffect(()=>{
        if(clearInputBox) {
            setCurrentPatientId(null)
        }
    },[clearInputBox])

    useEffect(() => {
        (async () => {
            const patientList = await fetchProviderGroupMembers(providerId);
            setPatients(
                patientList && patientList.data.map(p => ({
                    label: `${p.patientInfo.patientFullName} (${moment
                        .utc(p.patientInfo.patientBirthdate)
                        .format('MM/DD/YYYY')})`,
                    info: p,
                }))
            );
        })();
    }, [patientInfo]);


    

    // filtering patient names patient names appropriately when search bar is typed into
    const filterPatients = async patientName => {
        if (onChange) onChange(patientName);
        return patients
            .filter(
                customFilter ||
                ((patient, i) =>
                    patient.label.toLowerCase().includes(patientName.toLowerCase()))
            )
            .slice(0, maxOptions);
    };

    const handleSelectionBeingMade = async patient => {
        if (patient) {
            await onSelect(patient.info).label;
            setCurrentPatientId(patient.info.label)
        } 
        else {
                const patientList = await fetchProviderGroupMembers(providerId);
                props.handleRender(patientList)
        }
    };

    const getList = async (inputValue) => {
        const patientList = await fetchProviderGroupMembers(providerId);
        const data = patientList.map(p => ({
            label: `${p.patientInfo.patientFullName} (${moment
                .utc(p.patientInfo.patientBirthdate)
                .format('MM/DD/YYYY')})`,
            value: p.id,
            info: p,
        }))
        setPatients(data);
        return data
            .filter(
                customFilter ||
                ((patient, i) =>
                    patient.label.toLowerCase().includes(inputValue.toLowerCase()))
            )
            .slice(0, maxOptions);
    }


    return (
        <SearchableSelect
            noOptionsMessage={noOptionsMessage}
            clearable={clearable}
            disabled={disabled}
            searchable={searchable}
            fetchAsyncOptions={filterPatients}
            placeholder={placeholder}
            label={label}
            name={name}
            onChange={handleSelectionBeingMade}
            value={currentPatientId}
            options={[]}
            className={selectInput}
            error={!!errorMessage}
            errorMessages={errorMessage}
            getList={getList}
        />
    );
}

PatientSearchUnderProvider.propTypes = {
    id: PropTypes.string,
    onSelect: PropTypes.func,
    onChange: PropTypes.func,
    customFilter: PropTypes.func,
    placeholder: PropTypes.string,
    practiceId: PropTypes.string,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    errorMessage: PropTypes.string,
    name: PropTypes.string,
    maxOptions: PropTypes.number,
    searchable: PropTypes.bool,
    disabled: PropTypes.bool,
};

const styles = () => ({
    selectInput: {
        marginTop: '0.5em',
        marginBottom: '1em',
    },
});

export default withStyles(styles)(PatientSearchUnderProvider);
